// extracted by mini-css-extract-plugin
module.exports = {"tab":"a10a3f92e9--tab--ezFxv","icon":"a10a3f92e9--icon--J14CE"};